import React from "react";
import { AppBar, Stack, Toolbar, IconButton } from "@mui/material";
import { Menu } from "lucide-react";
import Logo from "../logo";
import AccountPopover from "./AccountPopover";
import UserRoleChip from "./UserRoleChip";

const Header = ({ onMenuClick }) => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "#FFFFFF",
        maxHeight: 70,
        px: { xs: 0, md: 3 },
        boxShadow: "0 2px 8px rgba(26, 155, 142, 0.05)",
        borderRadius: 0,
        borderBottom: "2px solid #E0F7F5",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton
            onClick={onMenuClick}
            aria-label="Open menu"
            sx={{ display: { xs: "inline-flex", md: "none" }, color: "#0d9488" }}
          >
            <Menu size={22} />
          </IconButton>
          <Logo />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* <UserRoleChip /> */}
          <AccountPopover />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Header;